import { encodeSs58 } from "./ss58";

/**
 * Gateway ed25519 pubkey hex (bare or `0x`-prefixed) -> Cere SS58 address
 * (network prefix 54). Used to turn `useConfig().gatewayPublicKey` into the
 * `gateway` argument `ensureProvisioned` / `provisioning.ensure` expect.
 */
export function gatewayHexToSs58(hex: string): string {
  const clean = hex.startsWith("0x") ? hex.slice(2) : hex;
  const bytes = new Uint8Array(clean.length / 2);
  for (let i = 0; i < bytes.length; i++) bytes[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
  return encodeSs58(bytes, 54);
}
